import React, { useState } from 'react';
import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Sidebar from './Sidebar';
import Header from './Header';
import { useAuth } from '../../contexts';

const AppLayout = ({ children, onNavigate, currentPage }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);
  const { currentUser, logout } = useAuth();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar */}
      <Box
        component="nav"
        sx={{
          width: { xs: 0, md: 240 },
          flexShrink: { md: 0 },
        }}
      >
        {/* Sidebar móvil (temporal) */}
        {isMobile && (
          <Sidebar
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            onNavigate={onNavigate}
            currentPage={currentPage}
            user={currentUser}
          />
        )}
        
        {/* Sidebar desktop (permanente) */}
        {!isMobile && (
          <Sidebar
            variant="permanent"
            onNavigate={onNavigate}
            currentPage={currentPage}
            user={currentUser}
          />
        )}
      </Box>

      {/* Contenido principal */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          width: { xs: '100%', md: `calc(100% - 240px)` },
        }}
      >
        {/* Header */}
        <Header
          user={currentUser}
          onLogout={logout}
          onMenuToggle={handleDrawerToggle}
          showMenuButton={isMobile}
          currentPage={currentPage}
        />

        {/* Área de contenido */}
        <Box
          sx={{
            flexGrow: 1,
            padding: { xs: 2, sm: 3, md: 4 },
            marginTop: '64px', // Altura del header
            backgroundColor: '#f9fafb',
            minHeight: 'calc(100vh - 64px)',
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default AppLayout; 